import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "phone-input-wrapper"
}
const _hoisted_2 = ["value", "placeholder", "maxlength"]
const _hoisted_3 = {
  key: 1,
  class: "text-input-wrapper"
}
const _hoisted_4 = ["placeholder", "maxlength"]
const _hoisted_5 = { key: 2 }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { key: 3 }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { key: 4 }
const _hoisted_10 = { class: "code-input" }
const _hoisted_11 = ["onUpdate:modelValue", "onInput", "onKeydown"]
const _hoisted_12 = { key: 5 }
const _hoisted_13 = ["placeholder"]

import {
  ref,
  watch,
  nextTick,
  onMounted,
} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseInput',
  props: /*@__PURE__*/_mergeModels({
    type: {},
    placeholder: { default: "+7 (___) ___-__-__" },
    maxLength: { default: 10 },
    codeLength: { default: 4 },
    hasError: { type: Boolean, default: false }
  }, {
    "modelValue": { default: "" },
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels([
  //"update:modelValue",
  "complete",
  "validation",
  "change",
  "focus",
], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const props = __props;

const model = _useModel<string>(__props, "modelValue");

const emit = __emit;

const inputRef = ref<HTMLInputElement | null>(null);
const inputRefs = ref<HTMLInputElement[]>([]);

const displayValue = ref(model.value ?? "");
const codeValues = ref<string[]>(Array(props.codeLength).fill(""));

const allowedKeys = [
  "Backspace",
  "Delete",
  "Tab",
  "ArrowLeft",
  "ArrowRight",
  "ArrowUp",
  "ArrowDown",
  "Home",
  "End",
];

const validatePhone = () => {
  const digits = displayValue.value.replace(/\D/g, "");
  const isValid = digits.length === 11;
  emit("validation", { isValidPhone: isValid });
  return isValid;
};

watch(
  () => model.value,
  (newVal) => {
    emit("change", newVal);
    if (props.type === "phone") {
      displayValue.value = newVal ?? "";
      validatePhone();
    } else if (props.type === "code") {
      const newValues = (newVal ?? "").split("").slice(0, props.codeLength);
      for (let i = 0; i < props.codeLength; i++) {
        codeValues.value[i] = newValues[i] || "";
      }
    }
  }
);

const handlePhoneFocus = () => {
  if (displayValue.value === "") {
    displayValue.value = "+7 (";
    nextTick(() => {
      if (inputRef.value) {
        inputRef.value.setSelectionRange(4, 4);
      }
    });
    updatePhoneModel();
  }
};

const handlePhoneBlur = () => {
  if (displayValue.value === "+7 (") {
    displayValue.value = "";
    updatePhoneModel();
  }
};

const handlePhoneKeyDown = (e: KeyboardEvent) => {
  if (!inputRef.value) return;

  const start = inputRef.value.selectionStart ?? 0;
  const end = inputRef.value.selectionEnd ?? 0;

  if (allowedKeys.includes(e.key) || e.ctrlKey || e.metaKey || e.altKey) {
    return;
  }

  if (!/\d/.test(e.key)) {
    e.preventDefault();
    return;
  }

  if (e.key === "Backspace") {
    if (start === end) {
      if (start <= 4) e.preventDefault();
    } else {
      if (start < 4 || end <= 4) e.preventDefault();
    }
  } else if (e.key === "Delete") {
    if (start === end) {
      if (start < 4) e.preventDefault();
    } else {
      if (start < 4) e.preventDefault();
    }
  }
};

const handleDigitInput = (e: Event) => {
  if (!e.target?.value) return;
  let value = e.target?.value;
  value = value.replace(/[^0-9]/g, "");
  e.target.value = value;
  model.value = value;
};

const handleEmailInput = (e: Event) => {
  let value = e.target?.value;
  value = value.replace(/[^a-zA-Z0-9@+._%-]/g, "");
  model.value = value;
};

const handleEmailFocus = (): void => {
  emit("focus");
};

const validateEmail = (): void => {
  const emailRegex =
    /^[a-zA-Z0-9+._%-]{1,256}@[a-zA-Z0-9][a-zA-Z0-9-]{0,64}(\.[a-zA-Z0-9][a-zA-Z0-9-]{0,25})+$/;
  if (model.value) {
    emit("validation", emailRegex.test(model.value as string));
  } else emit("validation", true);
};

const handlePhoneInput = (e: Event) => {
  const target = e.target as HTMLInputElement;
  let value = target.value;

  let digits = value.replace(/\D/g, "");

  let validPhone = digits;
  if (
    digits.length === 12 &&
    (digits.startsWith("77") || digits.startsWith("78"))
  ) {
    validPhone = digits.substring(1, 12);
  }

  const maxDigits = props.maxLength + 1;
  const limitedDigits = validPhone.substring(0, maxDigits);

  let formatted = "+7 (";
  if (limitedDigits.length > 1) {
    const rest = limitedDigits.substring(1);
    formatted += rest.substring(0, 3);
    if (rest.length > 3) {
      formatted += ") " + rest.substring(3, 6);
    }
    if (rest.length > 6) {
      formatted += "-" + rest.substring(6, 8);
    }
    if (rest.length > 8) {
      formatted += "-" + rest.substring(8, 10);
    }
  }

  displayValue.value = formatted;
  updatePhoneModel();
  validatePhone();

  nextTick(() => {
    if (inputRef.value) {
      const pos = formatted.length;
      inputRef.value.setSelectionRange(pos, pos);
    }
  });
};

const updatePhoneModel = () => {
  //emit("update:modelValue", displayValue.value);
  model.value = displayValue.value;
};

const handleCodeInput = (e: Event, index: number) => {
  const target = e.target as HTMLInputElement;
  const value = target.value;

  if (value.length > 1) {
    const lastChar = value.charAt(value.length - 1);
    codeValues.value[index] = lastChar;
    focusNextCodeInput(index);
    updateCodeModel();
    return;
  }

  if (value) {
    focusNextCodeInput(index);
  }

  updateCodeModel();
};

const handleCodeKeyDown = (e: KeyboardEvent, index: number) => {
  if (allowedKeys.includes(e.key) || e.ctrlKey || e.metaKey || e.altKey) {
    if (e.key === "Backspace" && !codeValues.value[index] && index > 0) {
      e.preventDefault();
      codeValues.value[index - 1] = "";
      focusPrevCodeInput(index);
      updateCodeModel();
    }
    return;
  }

  if (!/\d/.test(e.key)) e.preventDefault();
};

const handleCodePaste = (e: ClipboardEvent) => {
  e.preventDefault();
  const pasteData =
    e.clipboardData?.getData("text/plain").replace(/\D/g, "") || "";

  const limitedPaste = pasteData.substring(0, props.codeLength);

  for (let i = 0; i < props.codeLength; i++) {
    codeValues.value[i] = i < limitedPaste.length ? limitedPaste[i] : "";
  }

  updateCodeModel();

  const lastFilledIndex = Math.min(
    limitedPaste.length - 1,
    props.codeLength - 1
  );
  focusCodeInput(lastFilledIndex);
};

const handleCodeFocus = () => {
  const firstEmptyIndex = codeValues.value.findIndex((val) => val === "");
  if (firstEmptyIndex !== -1) {
    focusCodeInput(firstEmptyIndex);
  } else {
    focusCodeInput(props.codeLength - 1);
  }
};

const focusCodeInput = (index: number) => {
  nextTick(() => {
    const input = inputRefs.value[index];
    if (input) {
      input.focus();
    }
  });
};

const focusNextCodeInput = (index: number) => {
  if (index < props.codeLength - 1) {
    focusCodeInput(index + 1);
  } else {
    emit("complete");
  }
};

const focusPrevCodeInput = (index: number) => {
  if (index > 0) {
    focusCodeInput(index - 1);
  }
};

const updateCodeModel = () => {
  const code = codeValues.value.join("");
  //emit("update:modelValue", code);
  model.value = code;
  if (code.length === props.codeLength) {
    emit("complete");
  }
};
const validationValueInit = () => {
  if (props.type === "email" && model.value) {
    validateEmail();
  }
};
onMounted(() => {
  validationValueInit();
});

return (_ctx: any,_cache: any) => {
  return (_ctx.type === 'phone')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("input", {
          ref_key: "inputRef",
          ref: inputRef,
          value: displayValue.value,
          placeholder: _ctx.placeholder,
          onInput: handlePhoneInput,
          onFocus: handlePhoneFocus,
          onBlur: handlePhoneBlur,
          onKeydown: handlePhoneKeyDown,
          class: _normalizeClass(["base-input color-text-primary phone-input caption-medium", { error: _ctx.hasError }]),
          type: "tel",
          maxlength: _ctx.maxLength + 6
        }, null, 42, _hoisted_2)
      ]))
    : (_ctx.type === 'digit')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            ref_key: "inputRef",
            ref: inputRef,
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
            placeholder: _ctx.placeholder,
            onInput: handleDigitInput,
            maxlength: _ctx.maxLength,
            class: _normalizeClass(["base-input color-text-primary text-input caption-medium", { error: _ctx.hasError }])
          }, null, 42, _hoisted_4), [
            [_vModelText, model.value]
          ])
        ]))
      : (_ctx.type === 'email')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              ref_key: "inputRef",
              ref: inputRef,
              type: "email",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model).value = $event)),
              placeholder: _ctx.placeholder,
              onInput: handleEmailInput,
              onBlur: validateEmail,
              onFocus: handleEmailFocus,
              class: _normalizeClass(["base-input color-text-primary text-input caption-medium", { error: _ctx.hasError }])
            }, null, 42, _hoisted_6), [
              [_vModelText, model.value]
            ])
          ]))
        : (_ctx.type === 'text')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                ref_key: "inputRef",
                ref: inputRef,
                type: "text",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((model).value = $event)),
                placeholder: _ctx.placeholder,
                class: _normalizeClass(["base-input color-text-primary text-input caption-medium", { error: _ctx.hasError }])
              }, null, 10, _hoisted_8), [
                [_vModelText, model.value]
              ])
            ]))
          : (_ctx.type === 'code')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array(_ctx.codeLength).fill(0), (_, index) => {
                    return _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: index,
                      ref_for: true,
                      ref: 
          (el) => {
            inputRefs.value[index] = el;
          }
        ,
                      "onUpdate:modelValue": ($event: any) => ((codeValues.value[index]) = $event),
                      onInput: (e) => handleCodeInput(e, index),
                      onKeydown: (e) => handleCodeKeyDown(e, index),
                      onPaste: handleCodePaste,
                      onFocus: handleCodeFocus,
                      maxlength: "1",
                      class: "code-input__box h2 color-text-primary",
                      type: "tel"
                    }, null, 40, _hoisted_11)), [
                      [_vModelText, codeValues.value[index]]
                    ])
                  }), 128))
                ])
              ]))
            : (_ctx.type === 'area')
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _withDirectives(_createElementVNode("textarea", {
                    class: "area-input base-input color-text-primary caption-medium",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((model).value = $event)),
                    name: "text-area",
                    id: "text-area",
                    cols: "30",
                    rows: "10",
                    placeholder: _ctx.placeholder
                  }, null, 8, _hoisted_13), [
                    [_vModelText, model.value]
                  ])
                ]))
              : _createCommentVNode("", true)
}
}

})